<p-toast></p-toast>
<p-confirmDialog key="stationPairingConfirm" [style]="{ width: '480px' }"></p-confirmDialog>
<p-confirmDialog key="stationDeleteConfirm" [style]="{ width: '480px' }"></p-confirmDialog>

<!-- On a phone the page area already has its padding: the card goes edge to edge of it. -->
<div class="px-0 py-2 md:p-2">
  <div class="main-card p-3">
    <div class="font-semibold text-xl mb-2">Dodaj stanowisko</div>
    <p class="intro">
      Otwórz <strong>{{ internalExamUrl }}</strong> na komputerze, który ma służyć jako stanowisko, i wybierz
      „Zaloguj jako OSK”. Stanowisko pokaże kod – wpisz go poniżej albo zeskanuj kod QR ze stanowiska telefonem
      zalogowanym do panelu. Hasło OSK nie jest wtedy wpisywane na komputerze kursantów.
    </p>

    <form [formGroup]="pairingForm" (ngSubmit)="pairStation()" autocomplete="off">
      <div class="form-decorator top-decorator flex align-items-center">
        <label class="title" for="station-pairing-code">Kod ze stanowiska</label>
        <div class="form-wraper">
          <input
            id="station-pairing-code"
            type="text"
            pInputText
            class="pairing-code"
            [class.from-qr]="codeFromQr"
            formControlName="code"
            maxlength="9"
            placeholder="ABCD-EFGH"
            autocapitalize="characters"
            spellcheck="false"
            (input)="onCodeInput()"
          />
          @if (pairingForm.controls.code.touched && pairingForm.controls.code.invalid) {
            <small class="error-message">Wpisz 8 znaków kodu widocznego na stanowisku.</small>
          }
          @if (pairingError) {
            <small class="error-message">{{ pairingError }}</small>
          }
          <small class="hint">
            Wpisuj tylko kod widoczny na ekranie stanowiska w Twoim ośrodku – nigdy kod podany przez telefon czy e-mail.
          </small>
        </div>
      </div>

      <div class="flex justify-content-end mt-3">
        <p-button
          type="submit"
          label="Sparuj stanowisko"
          icon="pi pi-link"
          [styleClass]="promptPairing ? 'pairing-attention' : ''"
          [loading]="pairing"
          [disabled]="pairingForm.invalid || pairing"
          data-clarity-unmask="true"
        ></p-button>
      </div>
    </form>
  </div>

  <div class="main-card p-3 mt-3">
    <div class="flex justify-content-between align-items-center mb-2">
      <div class="font-semibold text-xl">Stanowiska OSK</div>
      <p-button
        icon="pi pi-refresh"
        [text]="true"
        [rounded]="true"
        [loading]="loadingDevices"
        ariaLabel="Odśwież listę stanowisk"
        (onClick)="loadDevices()"
        data-clarity-unmask="true"
      ></p-button>
    </div>

    @if (!loadingDevices && devices.length === 0) {
      <p class="text-sm text-400 m-0">Brak stanowisk. Dodaj pierwsze kodem powyżej.</p>
    }

    <ul class="station-list">
      @for (device of devices; track device.guid) {
        <li class="station-row">
          <i class="pi pi-desktop"></i>
          <span class="station-name">{{ device.name }}</span>
          <span class="station-status" [class.online]="device.online">
            {{ device.online ? 'Połączone' : 'Offline' }}
          </span>
          <small class="station-seen">Ostatnio: {{ device.lastSeenAtUtc | date: 'dd.MM.yyyy HH:mm' }}</small>
          <p-button
            class="station-delete"
            icon="pi pi-trash"
            [text]="true"
            [rounded]="true"
            [style]="{ width: '2.25rem', height: '2.25rem' }"
            severity="secondary"
            [ariaLabel]="'Usuń stanowisko ' + device.name"
            pTooltip="Usuń stanowisko"
            tooltipPosition="bottom"
            [loading]="deletingDeviceGuid === device.guid"
            [disabled]="deletingDeviceGuid !== null"
            (onClick)="requestDeviceDeletion(device)"
            data-clarity-unmask="true"
          ></p-button>
        </li>
      }
    </ul>
  </div>
</div>
